<ng-container *transloco="let _t">

<div class="row details">
	<div class="col-3">
		<cmat-picture [src]="model.photo" [alt]="'Photo de l\'établissement'" [uploadable]="false">
		</cmat-picture>
	
		<h2>
			{{model.name}} 
			<small>( {{model.BuildingType.name}} )</small>
		</h2>
		
		<div class="building-infos">
			<h3>{{ _t('building-sheet-h3-0') }} </h3>
			<p>{{model.adress1}}<br/> 
				<span *ngIf="model.adress2!=undefined">
					{{model.adress2}}<br/></span>
				{{model.zipcode}} {{model.town}} <br/>
				{{model.region}} - {{model.country}}
			</p>

			<h3>{{ _t('building-sheet-h3-1') }}</h3>
			<h4>{{ _t('building-sheet-h4-0') }}</h4>
			<p> {{model.User.name}} <br>
			 <a [href]="'mailto:'+model.User.email">{{model.User.email}}</a>
			 <br>
			 {{model.User.phone}}</p>

			<h4>{{ _t('building-sheet-h4-1') }}</h4>
			<p>{{model.director}} <br>
			 <a [href]="'mailto:'+model.User.email">{{model.email}}</a>
			 <br>
			 {{model.phone}}</p>


			<h3>{{ _t('building-sheet-h3-2') }}</h3>
			<p>{{model.notes}}</p>
		</div>
	</div>
	

	<div class="col-9 row">
		
		<mat-tab-group #tabGroup (selectedTabChange)="handleTabChange($event)" [selectedIndex]="activeTabIndex"> 
			<mat-tab selected>
				<ng-template mat-tab-label>
					<mat-icon>youtube_searched_for</mat-icon> &nbsp; 
					{{ _t('Audits') }}
				</ng-template>

				<div class="tabcontent" *ngIf="activedTabIndex.includes(0)" >
				<p class="right">
					<button mat-raised-button color="accent"
						(click)="auditlist.newDiagnostic()">
						<mat-icon class="md-12">add</mat-icon>
						{{ _t('building-sheet-button-0') }}
					</button>
				</p>
				<h2>{{ _t('building-sheet-h2-0') }}</h2>
				<audit-list	[building]="model" #auditlist></audit-list>
			</div></mat-tab>
			<mat-tab>

				<ng-template mat-tab-label>
					<mat-icon>sync_problem</mat-icon> &nbsp; 
					{{ _t('Incidents') }}
				  </ng-template>

				<div class="tabcontent" *ngIf="activedTabIndex.includes(1)" >
				<p class="right">
				<button mat-raised-button color="danger"
					(click)="gotoIncidents()">
					<mat-icon class="md-12">sync_problem</mat-icon>
					{{ _t('building-sheet-button-1') }}
				</button>
				&nbsp;
				<button mat-raised-button color="accent"
					(click)="goto('incidents', '/new')">
					<mat-icon class="md-12">report_problem</mat-icon>
					{{ _t('building-sheet-button-2') }}
				</button>
				</p>
				<h2>{{ _t('building-sheet-h2-1') }}</h2>
				<incident-list 
					[selectedBuildingsList]="[model.id]"
					(openTriggered)="goto('incidents', '/'+$event.id)">
				</incident-list>
				<p></p>
			</div></mat-tab>

			<mat-tab>
				
				<ng-template mat-tab-label>
					<mat-icon>show_chart</mat-icon> &nbsp; 
					{{ _t('Statistics') }}
				  </ng-template>

				<div class="tabcontent" *ngIf="activedTabIndex.includes(2)" >
				<p class="right">
					<button mat-raised-button color="primary"
						(click)="goto('statistiques')">
						<mat-icon class="md-12">show_chart</mat-icon>
						{{ _t('building-sheet-button-3') }}
					</button>
				</p>
				<h2>{{ _t('building-sheet-h2-2') }}{{stats.currentYear}}</h2>
				<statistics-stats [fullPage]="false" [openedBuildingIdD]="model.id" #stats>
				</statistics-stats>
			</div></mat-tab>

			
			<mat-tab>
				
				<ng-template mat-tab-label>
					<mat-icon>description</mat-icon> &nbsp; 
					{{ _t('Data-sheet') }}
				  </ng-template>

				<div class="tabcontent" *ngIf="activedTabIndex.includes(3)" >
				<building-datasheet *ngIf="activeTabIndex==3"
					[building]="model"
					(saveTriggered)="save($event);"></building-datasheet> 
			</div></mat-tab>

		</mat-tab-group>

	</div>

</div>

</ng-container>